import React from 'react';
import { useNavigate } from 'react-router-dom';
import './homePage.scss';

const HomePage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/registration');
  };

  return (
    <div className="home-page page-container">
      <div className="welcome-message">
        <div className="welcome-message-header">
          <h1>Welcome to the LeapFrog Lab Online Registration</h1>
        </div>
        <button className="button primary" onClick={handleContinue}>
          Continue
        </button>
      </div>
      <div className="highlighted-block">
        <p>
          By completing this form, you will join our local Bay Area community of
          families and educators who help us test products so that they reach
          the highest standards of education, learning, and fun. This form asks
          for information about you and your child so that the LeapFrog Lab may
          contact you for different types of product testing, such as on-site
          visits, in-home testing, or email surveys. Participation in these
          activities is entirely optional.
        </p>
        <br />
        <br />
        <p>
          <strong>Eligibility:</strong> I represent that neither I nor any
          member of my immediate family is an employee of, or otherwise related
          to, any toy manufacturer, distributor, or retailer, any company in the
          news media industry, including television, radio, print, and online
          news media companies, or any marketing or advertising company. I
          understand that LeapFrog does not provide participant transportation
          to or from its testing sites.
        </p>
      </div>
    </div>
  );
};

export default HomePage;
